export function getToken() {
  return localStorage.getItem('token');
}

export function getUsuario() {
  const u = localStorage.getItem('usuario');
  return u ? JSON.parse(u) : null;
}

export function logout() {
  localStorage.removeItem('token');
  localStorage.removeItem('usuario');
}

export function authHeaders() {
  const token = getToken();
  return token ? { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json' };
}

export function isAuthenticated() {
  return !!getToken();
}

export async function apiFetch(url, options = {}) {
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
    ...(options.headers || {}),
  };
  const res = await fetch(url, { ...options, headers });

  // Sesión vencida o token inválido: el backend responde 401/403 (a veces con
  // cuerpo vacío). En vez de dejar que el componente falle al hacer res.json(),
  // limpiamos la sesión y volvemos al login.
  if ((res.status === 401 || res.status === 403) && token) {
    logout();
    sessionStorage.setItem('sesionExpirada', '1');
    window.location.reload();
  }
  return res;
}
